import { COPPER } from '../constants/globals';
import { inchToString } from './unitConversions';

export function constructionToStr(material) {
  if (Array.isArray(material)) {
    return prepregConstructionToStr(material)
  } else {
    return coreConstructionToStr(material);
  }
}

export function singleConstructionToStr(material) {
  const { construction } = material;
  if (construction === undefined) {
    return "";
  }

  const glasses = construction.map(glass => {
      return `${glass.layers}x${glass.glassType}`;
  });

  return glasses.join("/");
}

export function coreConstructionToStr(material) {
  return singleConstructionToStr(material);
}

export function prepregConstructionToStr(materials = []) {
  const glasses = {};
  materials.forEach(m => {
    const { material, count } = m;
    (material.construction || []).forEach(glass => {
      const { layers, glassType } = glass;
      if (glasses[glassType] !== undefined) {
        glasses[glassType] += count * layers;
      } else {
        glasses[glassType] = count * layers;
      }
    });
  });

  return Object.keys(glasses).map(glass => {
    return `${glasses[glass]}x${glass}`;
  }).join('/');
}

export function thickness2inch(thickness) {
  return thickness;
}

export function resinContentToPercent(resinContent) {
  return resinContent * 100;
}

export function materialToStr(material, unit) {
  const { thickness, product } = material;
  const thicknessString = inchToString(thickness, unit);
  return `${product} ${coreConstructionToStr(material)}(${thicknessString})`;
}

export function coreToString(material, unit) {
  if (material === undefined) {
    return '';
  }

  return materialToStr(material, unit);
}

export function prepregToString(material, unit) {
  if (material === undefined) {
    return '';
  }
  const thickness = material
    .reduce((acc, cur) => {
      return acc + cur.count * cur.material.thickness;
    }, 0)
    .toFixed(4);
  const manufacturers = material
    .map(m => m.material.manufacturer)
    .filter((value, index, self) => self.indexOf(value) === index)

  const manufacturer = manufacturers.length > 1 ? manufacturers.join('/') : '';

  const product = material
    .map(m => m.material.product)
    .filter((value, index, self) => self.indexOf(value) === index)
    .join('/');

  const str = `${manufacturer} ${product} ${prepregConstructionToStr(material)}(${inchToString(thickness, unit)})`.trim();
  return str;
}

export function prepregsIdentical(a, b) {
  if (a.length !== b.length) {
    return false;
  }
  // turn array of materials into object form of { id: count }
  const target = b.reduce((acc, cur) => {
    const id = cur.material.id;
    acc[id] = cur.count;
    return acc;
  }, {});

  return a.reduce((acc, cur) => {
    const { count, material } = cur;
    return acc && 
      target[material.id] !== undefined &&
      target[material.id] === count
  }, true)
}

export function materialToChartData(materials, attr, decimal, lengthUnit) {
  const names = new Set();

  const data = materials.reduce((valueObj, material) => {
    const values = material[attr];
    const name = materialToStr(material, lengthUnit);
    names.add(name);

    valueObj = values.reduce((acc, item) => {
      const dataObj = acc[item.mhz];
      const value = isNaN(decimal) ? item.value : Number(item.value.toFixed(decimal));
      if (dataObj === undefined) {
        acc[item.mhz] = { [name]:  value };
      } else {
        acc[item.mhz][name] = value;
      }
      return acc;
    }, valueObj)
    return valueObj;
  }, {});
  const mhzs = Object.keys(data);
  const chartData = mhzs.map(mhz => {
    data[mhz]['mhz'] = mhz;
    return data[mhz];
  })

  return {
    data: chartData,
    keys: Array.from(names),
    mhzs
  };
}

export function isOuterCopper(copper, layers) {
  // if type index is not set, this copper is not part of stackup.
  // therefore, it is not outer copper.
  if (copper.typeIndex === 0) {
    return false;
  }
  const { typeIndex } = copper;
  const copperCount = layers
    .map(layer => layer.type)
    .reduce((count, type) => type === COPPER ? count + 1 : count, 0);

  return typeIndex === 1 || copperCount === typeIndex;
}

export const extractMhzs = (materials, keys) => {
  const mhzs = new Set();
  materials.forEach(material => {
    keys.forEach(key => {
      material[key].forEach(datum => {
        mhzs.add(datum.mhz);
      });
    });
  });

  return Array
    .from(mhzs)
    .sort((a, b) => Number(a) - Number(b));
}



// WEBPACK FOOTER //
// ./src/lib/material.js